import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    detailChannel = new Subject();
    indexChannel = new Subject()
    downloadDRHChannel = new Subject();
    downloadDRHdocChannel = new Subject();
    imagesChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
        this.downloadDRHChannel.next({status: apiResponse.INITIAL})
        this.downloadDRHdocChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchDownloadDRH = async (query) => {
        try {
            this.downloadDRHChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadDRH(query).then((result) => {
                this.downloadDRHChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadDRHChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    fetchDownloadDRHdoc = async (query) => {
        try {
            this.downloadDRHdocChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadDRHdoc(query).then((result) => {
                this.downloadDRHdocChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadDRHdocChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchImages = async (query) => {
        try {
            this.imagesChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchImages(query).then((result) => {
                this.imagesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.imagesChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
}

export default IndexBloc